import React, { Component } from "react";
import man from "../../../assets/images/dashboard/user2.jpg";
import { connect } from "react-redux";

export class User_panel extends Component {
  render() {
    const { currentAdmin } = this.props;
    return (
      <div className="sb-user-card">
        {currentAdmin && currentAdmin.image ? (
          <img
            className="lazyloaded blur-up"
            src={currentAdmin.image}
            alt={currentAdmin.name}
          />
        ) : (
          <img
            className="lazyloaded blur-up"
            src={man}
            alt="user"
          />
        )}
        <div className="sb-user-info">
          <p className="sb-user-name">{currentAdmin ? currentAdmin.name : ""}</p>
          <span className="sb-user-role">{currentAdmin ? currentAdmin.status : ""}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin: state.admins.currentAdmin,
});

export default connect(mapStateToProps, null)(User_panel);
